import React from 'react';
import { Bar, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ComposedChart } from 'recharts';

const RiskScoreChart = ({ data }) => {
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-popover border border-border rounded-lg p-3 shadow-lg">
          <p className="text-sm font-medium text-popover-foreground mb-2">{label}</p>
          {payload?.map((entry, index) => (
            <div key={index} className="flex items-center justify-between gap-4 text-xs">
              <span className="text-muted-foreground">{entry?.name}:</span>
              <span className="font-semibold" style={{ color: entry?.color }}>
                {entry?.name === 'Volume Transaksi' ? entry?.value : `${entry?.value}%`}
              </span>
            </div>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card border border-border rounded-xl p-4 md:p-6 shadow-sm">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
        <div>
          <h3 className="text-base md:text-lg font-semibold text-foreground mb-1">
            Distribusi Skor Risiko
          </h3>
          <p className="text-xs md:text-sm text-muted-foreground">
            Analisis pola risiko transaksi dalam 24 jam terakhir
          </p>
        </div>
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-error"></div>
            <span className="text-xs text-muted-foreground">Skor Risiko</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-primary"></div>
            <span className="text-xs text-muted-foreground">Volume</span>
          </div>
        </div>
      </div>

      <div className="w-full h-64 md:h-80 lg:h-96" aria-label="Risk Score Distribution Chart">
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart data={data} margin={{ top: 5, right: 10, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="time" 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
            />
            <YAxis 
              yAxisId="left"
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
              label={{ value: 'Skor Risiko (%)', angle: -90, position: 'insideLeft', style: { fontSize: '12px' } }}
            />
            <YAxis 
              yAxisId="right"
              orientation="right"
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
              label={{ value: 'Volume', angle: 90, position: 'insideRight', style: { fontSize: '12px' } }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend 
              wrapperStyle={{ fontSize: '12px' }}
              iconType="circle"
            />
            <Bar 
              yAxisId="left"
              dataKey="riskScore" 
              fill="var(--color-error)" 
              name="Skor Risiko"
              radius={[8, 8, 0, 0]}
            />
            <Line 
              yAxisId="right"
              type="monotone" 
              dataKey="volume" 
              stroke="var(--color-primary)" 
              strokeWidth={2}
              name="Volume Transaksi"
              dot={{ fill: 'var(--color-primary)', r: 4 }}
            />
          </ComposedChart>
        </ResponsiveContainer>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6 pt-6 border-t border-border">
        <div className="text-center">
          <p className="text-xs text-muted-foreground mb-1">Rata-rata Risiko</p>
          <p className="text-lg md:text-xl font-semibold text-error">67.8%</p>
        </div>
        <div className="text-center">
          <p className="text-xs text-muted-foreground mb-1">Puncak Risiko</p>
          <p className="text-lg md:text-xl font-semibold text-warning">89.2%</p>
        </div>
        <div className="text-center">
          <p className="text-xs text-muted-foreground mb-1">Total Transaksi</p>
          <p className="text-lg md:text-xl font-semibold text-primary">1,247</p>
        </div>
        <div className="text-center">
          <p className="text-xs text-muted-foreground mb-1">Anomali Terdeteksi</p>
          <p className="text-lg md:text-xl font-semibold text-error">23</p>
        </div>
      </div>
    </div>
  );
};

export default RiskScoreChart;